import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './button-svg-item.module.scss';

interface ButtonSvgItemProps {
  id: string;
  className?: string;
  text: string;
  svgPath: string;
  isSelected?: boolean;
  isDisabled?: boolean;

  onClick(id: string): void;
}

export function ButtonSvgItem({className = '', isSelected = false, isDisabled = false, ...props}: ButtonSvgItemProps): ReactElement<any> | null {
  return (
    <div
      id={props.id}
      onClick={(): void => {
        if (!isDisabled) {
          return props.onClick(props.id);
        }
      }}
      className={`${className} ${styles.container}  flex-column-align-center`}
    >
      <div className={`${styles.imgContainer} ${isDisabled ? styles.disabled : ''} ${isSelected ? styles.selected : ''} flex-center `}>
        <img className={`${styles.img} ${isDisabled ? styles.disabledImg : ''} ${isSelected && !isDisabled ? styles.selectedImg : ''}`} src={props.svgPath} alt="mySvgImage" />
      </div>
      <Text
        val={props.text}
        size={TextSize.XSMALL}
        className={`spacing-m-t-1 ${isDisabled ? 'color-extra-light' : 'content-sub-text'} ${isSelected && !isDisabled ? 'content-primary' : ''}`}
        bold={isSelected}
      />
    </div>
  );
}
